import React from 'react';
import { string, arrayOf, number, func } from 'prop-types';
import classnames from 'classnames';
import Tab from './Tab/Tab';

import './NavigationTabs.scss';

export default function NavigationTabs({
    className,
    activeTab,
    tabs,
    onTabChange,
}) {
    const rootClassnames = classnames('navigation-tabs', className);

    return (
        <div className={rootClassnames}>
            {tabs.map((tabName, index) => (
                <Tab
                    key={tabName}
                    className="navigation-tabs__tab"
                    index={index}
                    name={tabName}
                    active={index === activeTab}
                    onClick={onTabChange}
                />
            ))}
        </div>
    );
}

NavigationTabs.propTypes = {
    className: string,
    activeTab: number,
    tabs: arrayOf(string).isRequired,
    onTabChange: func,
};

NavigationTabs.defaultProps = {
    className: null,
    activeTab: -1,
    onTabChange: null,
};
